export * from '@fhs/routing/src/routes/(drawer)/account/info';
export { default } from '@fhs/routing/src/routes/(drawer)/account/info';
